(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('candrin-navigation')) {
  customElements.define('candrin-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const details = this.querySelector('details');
      const trigger = details.querySelector('summary');
      const close = (focus = false) => { clearTimeout(this.closeTimer); details.open = false; if (focus) trigger.focus(); };
      const isDesktop = () => matchMedia('(min-width: 750px) and (hover: hover)').matches;
      trigger.addEventListener('click', e => { if (isDesktop() && e.detail > 0) { e.preventDefault(); details.open = true; } }, options);
      trigger.addEventListener('pointerenter', () => { if (isDesktop()) { clearTimeout(this.closeTimer); details.open = true; } }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('pointerleave', () => { if (isDesktop() && !this.contains(document.activeElement)) this.closeTimer = setTimeout(() => close(), 180); }, options);
      this.addEventListener('keydown', e => { if (e.key === 'Escape' && details.open) { e.preventDefault(); close(true); } }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) close(); }, options);
      this.querySelector('.cn-mega__close').addEventListener('click', () => close(true), options);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) close(); }, options);
      window.addEventListener('resize', () => close(), options);
      details.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(details.open)), options);
      trigger.setAttribute('aria-expanded', String(details.open));
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.closeTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
